/**
 * Web component for collection interstitial gallery carousels.
 * Initializes in connectedCallback so it works when the section is re-rendered
 * (e.g. after clearing filters) and scripts inside innerHTML are not executed.
 */
class CollectionGalleryCarousel extends HTMLElement {
  constructor() {
    super();
    this._swiper = null;
    this._hotspotCleanup = null;
    this._mediaQuery = null;
    this._onBreakpointChange = null;
  }

  connectedCallback() {
    const viewport = this.dataset.interstitialViewport;
    if (viewport) {
      this._mediaQuery = window.matchMedia('(min-width: 768px)');
      this._onBreakpointChange = () => this.syncViewport();
      this._mediaQuery.addEventListener('change', this._onBreakpointChange);
      this.syncViewport();
      return;
    }

    this.initializeCarousel();
  }

  disconnectedCallback() {
    if (this._mediaQuery && this._onBreakpointChange) {
      this._mediaQuery.removeEventListener('change', this._onBreakpointChange);
    }
    this._mediaQuery = null;
    this._onBreakpointChange = null;
    this.destroyCarousel();
  }

  syncViewport() {
    const isDesktop = this._mediaQuery.matches;
    const shouldBeActive = this.dataset.interstitialViewport === 'desktop' ? isDesktop : !isDesktop;

    if (shouldBeActive) {
      this.initializeCarousel();
    } else {
      this.destroyCarousel();
    }
  }

  initializeCarousel() {
    const carousel = this.querySelector('.swiper.collection-gallery-carousel');
    if (!carousel || this._swiper || carousel.swiper) return;

    if (typeof Swiper !== 'undefined') {
      this._swiper = new Swiper(carousel, {
        loop: true,
        autoplay: false,
        autoHeight: false,
        pagination: {
          el: carousel.querySelector('.swiper-pagination'),
          clickable: true,
        },
        on: {
          autoplayTimeLeft(s, time, progress) {
            const activeProgress = carousel.querySelector('.swiper-pagination-bullet-active');
            if (activeProgress) {
              activeProgress.style.background = `linear-gradient(to right, white ${(1 - progress) * 100}%, rgba(255,255,255,0.2) ${(1 - progress) * 100}%)`;
            }
          },
        },
      });
    }

    if (typeof window.initHotspotsForCarousel === 'function') {
      this._hotspotCleanup = window.initHotspotsForCarousel(carousel);
    }
  }

  destroyCarousel() {
    if (this._hotspotCleanup) {
      this._hotspotCleanup();
      this._hotspotCleanup = null;
    }
    if (this._swiper) {
      this._swiper.destroy(true, true);
      this._swiper = null;
    }
  }
}

customElements.define('collection-gallery-carousel', CollectionGalleryCarousel);
